<template>
  <div>
    <b-modal
      size="lg"
      id="modal-1"
      title="اطلاعات تراکنش"
      ok-only
      ok-title="بستن"
    >
      <div class="row" v-if="transaction !== null">
        <div
          class="col-md-6 text-danger"
          v-if="transaction != null && transaction.refund != 0"
        >
          <b-form-group
            :label="
              this.api == undefined
                ? 'مبلغ بازگشت وجه (ریال):'
                : 'مبلغ بازگشت وجه (دلار)'
            "
          >
            <div class="form-control text-danger">
              {{ transaction.refund_cost.toLocaleString() }} ریال
            </div>
          </b-form-group>
        </div>
        <div
          class="col-md-6 text-danger"
          v-if="transaction != null && transaction.refund != 0"
        >
          <b-form-group label="کد رهگیری:">
            <div class="form-control text-danger">
              {{ transaction.refund_tracknumber }}
            </div>
          </b-form-group>
        </div>
        <div class="col-md-6">
          <b-form-group label="وضیعت تراکنش:">
            <div class="form-control">پرداخت شده</div>
          </b-form-group>
        </div>
        <div class="col-md-6">
          <b-form-group label="کد تراکنش:">
            <div class="form-control">
              {{ transaction.transaction_id }}
            </div>
          </b-form-group>
        </div>
        <div class="col-md-6">
          <b-form-group
            :label="
              this.api == undefined
                ? 'مبلغ تراکنش (ریال):'
                : 'مبلغ تراکنش (دلار)'
            "
          >
            <div class="form-control">
              {{ Number(transaction.cost).toLocaleString() }}
            </div>
          </b-form-group>
        </div>
        <div class="col-md-6">
          <b-form-group
            :label="this.api == undefined ? 'کارمزد (ریال):' : 'کارمزد (دلار)'"
          >
            <div class="form-control">
              {{ Number(getKarmozd()).toLocaleString() }}
            </div>
          </b-form-group>
        </div>
        <div class="col-md-6">
          <b-form-group
            :label="
              this.api == undefined
                ? 'مبلغ با احتساب کارمزد (ریال):'
                : 'مبلغ با احتساب کارمزد (دلار)'
            "
          >
            <div class="form-control">
              {{ Number(transaction.amount).toLocaleString() }}
            </div>
          </b-form-group>
        </div>
        <div class="col-md-6">
          <b-form-group
            :label="
              this.api == undefined
                ? 'موجودی پس از این تراکنش (ریال):'
                : 'موجودی پس از این تراکنش (دلار)'
            "
          >
            <div class="form-control">
              {{ Number(transaction.totalsum).toLocaleString() }}
            </div>
          </b-form-group>
        </div>
        <div v-if="transaction.transaction_id != null" class="col-md-6">
          <b-form-group label="آدرس درخواست دهنده:">
            <b-input-group>
              <template #append>
                <b-input-group-text
                  ><strong class="text-danger"
                    ><b-img
                      v-if="transaction.ip"
                      class="float-left pt-0"
                      :src="'media/svg/flags/Question-circle.svg'"
                      width="30"
                      height="20"
                    ></b-img></strong
                ></b-input-group-text>
              </template>
              <div class="form-control">
                {{ transaction.ip }}
              </div>
            </b-input-group>
          </b-form-group>
        </div>
        <div v-if="transaction.transaction_id != null" class="col-md-6">
          <b-form-group label="کد رهگیری پرداخت:">
            <div class="form-control">
              {{ transaction.sale_reference_id }}
            </div>
          </b-form-group>
        </div>
        <div v-if="transaction.transaction_id != null" class="col-md-6">
          <b-form-group label="شماره کارت:">
            <div class="form-control" dir="ltr">
              {{ transaction.card_holder_pan }}
            </div>
          </b-form-group>
        </div>
        <div v-if="transaction.transaction_id != null" class="col-md-6">
          <b-form-group label="شماره فاکتور:">
            <div class="form-control" dir="ltr">
              {{ transaction.order_id }}
            </div>
          </b-form-group>
        </div>
        <div class="col-md-6" v-if="transaction.transaction_id != null">
          <b-form-group label="شماره همراه:">
            <div class="form-control">
              {{ transaction.api_mobile }}
            </div>
          </b-form-group>
        </div>
      </div>
      <div>
        <b-form-group label="توضیحات" v-if="transaction != null">
          <div class="form-control">
            {{ transaction.api_description }}
          </div>
        </b-form-group>
      </div>
    </b-modal>

    <b-modal
      id="modal-refund"
      title="بازگشت وجه تراکنش"
      hide-header-close
      cancel-title=""
    >
      <b-alert :show="showError" variant="danger">
        <p v-for="item in errorText" :key="item.id">
          {{ item }}
          <span v-if="item == 'موجودی شما کافی نمی باشد'"
            >.برای افزایش شارژ
            <a
              @click="returnToRefund"
              style="color: blue; text-decoration: underline; cursor: pointer"
              >اینجا</a
            >
            کلیک کنید.</span
          >
        </p>
        <p></p>
      </b-alert>
      <div class="row">
        <div class="col-md-6">
          <b-form-group label="مبلغ تراکنش (ریال):">
            <div class="form-control">
              {{
                transaction != null
                  ? Number(transaction.cost).toLocaleString()
                  : 0
              }}
            </div>
          </b-form-group>
        </div>
        <div class="col-md-6">
          <b-form-group label="شماره تراکنش:">
            <div class="form-control">
              {{ transaction != null ? transaction.transaction_id : 0 }}
            </div>
          </b-form-group>
        </div>
        <div class="col-md-6">
          <b-form-group label="کد رهگیری:">
            <div class="form-control">
              {{ transaction != null ? transaction.sale_reference_id : 0 }}
            </div>
          </b-form-group>
        </div>
        <div class="col-md-6">
          <b-form-group label="مبلغ مورد نظر برای بازگشت وجه (ریال):">
            <NumberSeprator v-model="refundamount"></NumberSeprator>
          </b-form-group>
        </div>
      </div>
      <template #modal-footer="{}">
        <b-button variant="outline-secondary" @click="close"> انصراف </b-button>
        <b-button
          :class="'ml-3 ' + (show ? 'spinner spinner-light spinner-right' : '')"
          variant="success"
          :disabled="show"
          @click="RefundTransaction"
        >
          ثبت و ذخیره
        </b-button>
      </template>
    </b-modal>

    <TableShowData
      :url="api != undefined ? api : settlementstable.url"
      :fields="settlementstable.fields"
      :btns="settlementstable.btns"
      :params="settlementstable.params"
      :excelroute="'excelroute'"
    >
    </TableShowData>
  </div>
</template>
<script>
import NumberSeprator from "../../components/numberSeprator";
import TableShowData from "../../components/table.vue";
import httpHelper from "../../helpers/httpHelper";
import persianDate from "../../helpers/persianDate";
import { SET_BREADCRUMB } from "@/core/services/store/breadcrumbs.module";

export default {
  name: "transactionList",
  props: ["api"],
  data() {
    return {
      show: false,
      amount: 0,
      refundamount: 0,
      totalCredit: 0,
      transaction: null,
      modalRefund: false,
      showError: false,
      errorText: [],
      settlementstable: {
        url: "mytransactions",
        params: [
          {
            label: "از تاریخ:",
            field: "datefrom",
            type: "date-picker",
          },
          {
            label: "تا تاریخ:",
            field: "dateto",
            type: "date-picker",
          },
          {
            label: "کد رهگیری:",
            field: "sale_refrence_id",
            type: "text",
          },
          {
            label: "چهار رقم آخر کارت:",
            field: "cardholderpan",
            type: "text",
          },
          {
            label: "نوع تراکنش:",
            field: "transaction_type",
            type: "select",
            value: 1,
            options: [
              { value: "1", text: "همه تراکنش ها" },
              { value: "2", text: "فقط واریز" },
              { value: "3", text: "فقط برداشت" },
            ],
          },
          {
            label: "درگاه:",
            field: "acceptorcode",
            type: "select",
            options: [],
          },
        ],
        fields: [
          {
            key: "transaction_id",
            label: "شماره تراکنش",
          },
          {
            key: "website_name",
            label: "وبسایت",
          },
          {
            key: "cost",
            label:
              this.api == undefined
                ? "مبلغ تراکنش (ریال)"
                : "مبلغ تراکنش (دلار)",
            formatter(value, key, item) {
              if (item.reversed) return value * -1;
              if (value == null) return item.amount;
              return Number(value).toLocaleString();
            },
            tdClass(value, key, item) {
              var val = item.amount;
              return val > 0 ? "text-success" : "text-danger";
            },
          },
          {
            key: "karmozd",
            label: "مبلغ کامزد (دلار)",
            formatter(value, key, item) {
              if (item.cost == null) return 0;
              if (item.reversed) return 0;
              return Number(item.cost - item.amount).toLocaleString();
            },
            tdClass(value, key, item) {
              var val = item.cost - item.amount;
              return val > 0 ? "text-danger" : "text-success";
            },
          },
          {
            key: "amount",
            label:
              this.api == undefined
                ? "مبلغ پس از کسر کارمزد (ریال)"
                : "مبلغ پس از کسر کارمزد (دلار)",
            formatter(value, key, item) {
              if (item.reversed) return item.cost * (-1);
              return Number(value).toLocaleString();
            },
            tdClass(value, key, item) {
              var val = item.amount;
              return val > 0 ? "text-success" : "text-danger";
            },
          },
          {
            key: "title",
            label: "عنوان تراکنش",
            formatter(value, key, item) {
              console.log("item:", item);
              // console.log("api:",this.api);

              if (item.reversed && item.amount < 0) {
                return "بازگشت وجه تراکنش شماره " + item.transaction_id;
              } else if (item.transaction_id != null) {
                return (
                  "واریز بابت پرداخت شماره " +
                  item.transaction_id +
                  (item.refund
                    ? "(" +
                      Number(item.refund_cost).toLocaleString() +
                      " برگشت خورده است)"
                    : "")
                );
              } else if (item.transaction == null) {
                return "برداشت وجه و واریز به حساب ";
              } else return "برداشت وجه و واریز به حساب ";
            },
          },
          {
            key: "created_at",
            label: "تاریخ تراکنش",
            formatter(value, key, item) {
              return (
                persianDate.getDateByFormat(value) +
                " ساعت " +
                persianDate.getTime(value)
              );
            },
          },

          {
            key: "api_order_id",
            label: "شماره فاکتور",
          },

          {
            key: "totalsum",
            label: "موجودی",
            formatter(value, key, item) {
              return Number(value).toLocaleString();
            },
            tdClass(value, key, item) {
              var val = item.amount;
              return val > 0 ? "text-success" : "text-danger";
            },
          },

          {
            key: "btns",
            label: "عملیات",
          },
        ],
        btns:
          this.api == undefined
            ? [
                {
                  icon: "eye-fill",
                  handler: (t) => {
                    this.transaction = t;
                    this.$bvModal.show("modal-1");
                  },
                  title: "توضیحات",
                },
                {
                  icon: "reply-fill",
                  handler: (t) => {
                    this.transaction = t;
                    this.$bvModal.show("modal-refund");
                    // this.modalRefund=true;
                  },
                  title: "ریفاند",
                },
              ]
            : [
                {
                  icon: "eye-fill",
                  handler: (t) => {
                    this.transaction = t;
                    this.$bvModal.show("modal-1");
                  },
                  title: "توضیحات",
                },
              ],
      },
    };
  },
  components: {
    TableShowData,
    NumberSeprator,
  },
  methods: {
    close() {
      this.refundamount = 0;
      this.errorText = [];
      this.showError = false;
      this.$bvModal.hide("modal-refund");
    },
    returnToRefund() {
      this.$router.push("/refunds");
    },
    number(value) {
      return Number(value);
    },
    RefundTransaction() {
      this.show = true;
      httpHelper
        .postData("refund-transaction", {
          transaction_id: this.transaction.transaction_id,
          amount: this.refundamount,
        })
        .then((res) => {
          this.refundamount = 0;
          this.show = !this.show;

          if (res.success) {
            this.settlementstable.url =
              "mytransactions?t=" + new Date().getTime();
            this.amount = res.result.amount;
            this.$bvModal.hide("modal-refund");
            this.$makeToast(
              "success",
              "پرداخت موفق",
              `درخواست برگشت وجه به مبلغ ${this.amount} ریال با موفقیت ثبت گردید.`,
              5000
            );
          } else {
            this.showError = true;
            this.errorText = res.error;
          }
        });
    },
    getKarmozd() {
      return this.transaction.cost - this.transaction.amount;
      // if (this.transaction.doc) {
      //   var ddetails = this.transaction.doc.doc_details;
      //   for (let i = 0; i < ddetails.length; i++) {
      //     const element = ddetails[i];
      //     if (element.amount < 0) {
      //       return element.amount * -1;
      //     }
      //   }
      // }
      // return 0;
    },
    getData() {
      let api;
      api = this.api ? 1722 : 483;
      httpHelper.getData(`paymentgateways?money_type=${api}`).then((res) => {
        console.log(res);
        this.settlementstable.params[5].options = res.result
          // .filter((t) => {
          //   return t.mdid12_money_type == 483 || t.mdid12_money_type == 484;
          // })
          .map((t) => {
            return {
              text: t.website_name + " (" + t.website + ")",
              value: t.id,
            };
          });
      });
    },
    getRefundable() {
      httpHelper.getData("getrefundprice").then((res) => {
        this.totalCredit = Number(res.result).toLocaleString();
      });
    },
  },
  mounted() {
    this.$store.dispatch(SET_BREADCRUMB, [
      {
        title: "لیست تراکنش های ریالی",
      },
    ]);
    this.getData();
    this.getRefundable();
  },
};
</script>
<style scoped>
</style>